import { render, staticRenderFns } from "./Rosetta-Life.vue?vue&type=template&id=40d58f89"
import script from "./Rosetta-Life.vue?vue&type=script&lang=js"
export * from "./Rosetta-Life.vue?vue&type=script&lang=js"
import style0 from "./Rosetta-Life.vue?vue&type=style&index=0&id=40d58f89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports